import script from "./TheTooltipBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheTooltipBase.vue?vue&type=script&lang=ts&setup=true"

import "./TheTooltipBase.vue?vue&type=style&index=0&id=5e6e1a5d&lang=sass&setup=true"

const __exports__ = script;

export default __exports__